import $ from 'jquery';
import throttle from 'lodash.throttle';

const scrollNav = {

	init() {
		this.$header = $('[data-js-header="header"]');

		this.eventHandlers();
	},

	eventHandlers() {
		$(document).on('scroll',throttle(this.onScroll).bind(this));
	},

	onScroll() {
		if ($(document).scrollTop() > 50) {
			this.$header.addClass('active');
		} else {
			this.$header.removeClass('active');
		}
	}
}

$(document).ready(() => {
	scrollNav.init();
})
